<template>
  <!--==================
    component shows steps to add fund (operator)
    ===============-->

  <div class="position-relative">
    <div class="bg-light p-3 rounded">
      <h4 class="font-weight-bold text-center">{{ title }}</h4>
    </div>

    <form class="card mt-5">
      <div class="card-body">
        <!-- step one -->
        <div v-if="paymentStep == 1" class="col-md-10 m-auto">
          <div class="form-row col-8 mt-3 mx-0 align-items-center m-auto">
            <div class="form-group col-md-4 mt-0 mb-2">
              <input
                @input="currencyToTzs()"
                type="number"
                class="form-control"
                v-model="form.currencyAmount"
                :placeholder="currency"
              />
            </div>
            <div class="form-group col mt-0 mb-2 bg-dark rounded ml-md-4">
              <p class="text-light p-2 m-0">Total Tshs: {{ form.amount | currency }}</p>
            </div>
          </div>

          <div class="d-flex col-8 pt-5 m-auto">
            <button
              @click="setPaymentStep(2)"
              :disabled="!form.currencyAmount"
              type="button"
              class="btn btn-success m-auto btn-sm px-6"
            >
              NEXT
            </button>
          </div>
        </div>

        <!-- step two -->
        <div v-if="paymentStep == 2" class="col-md-10 m-auto">
          <div class="col-8 mt-3 m-auto">
            <h4 class="font-weight-bold text-center">
              Pay amount <span class="text-success">TZS {{ form.amount | currency }}</span> via
            </h4>

            <!-- payment methods selection -->
            <div class="cc-selector d-flex mt-5 justify-content-center">
              <div class="form-group mx-3">
                <input id="mobile" type="radio" value="mobile" v-model="form.creditcard" :disabled="submitPayment" />
                <label @click="setPaymentMethod('mobile')" class="drinkcard-cc mobile" for="mobile"></label>
              </div>

              <div class="form-group mx-3">
                <input
                  id="mastercard"
                  type="radio"
                  value="mastercard"
                  v-model="form.creditcard"
                  :disabled="submitPayment"
                />
                <label @click="setPaymentMethod('mastercard')" class="drinkcard-cc mastercard" for="mastercard"></label>
              </div>

              <div class="form-group mx-3">
                <input id="visa" type="radio" value="visa" v-model="form.creditcard" :disabled="submitPayment" />
                <label @click="setPaymentMethod('visa')" class="drinkcard-cc visa" for="visa"></label>
              </div>
            </div>

            <div class="d-flex mt-4 justify-content-center border rounded p-3">
              <!-- mobile methods -->
              <div v-if="paymentMethod == 'mobile'" class="my-3 col-md-6">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text p-0 px-2" id="input-phone">+255</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="phone number"
                    v-model="form.buyerPhone"
                    aria-describedby="input-phone"
                    :disabled="submitPayment"
                    @input="$v.form.buyerPhone.$touch()"
                  />
                </div>
                <span class="text-danger" v-if="$v.form.buyerPhone.$dirty && $v.form.buyerPhone.$invalid">
                  &nbsp; Bad phone number format
                </span>
              </div>

              <!-- card method -->
              <div v-if="paymentMethod == 'mastercard' || paymentMethod == 'visa'" class="col">
                <div class="d-flex justify-content-between">
                  <h5 class="font-weight-bold">Billing Details</h5>
                </div>
                <hr />

                <div class="col my-3">
                  <!-- Billing details -->
                  <div class="form-row">
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.fName"
                        placeholder="First Name"
                        @input="$v.form.fName.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.fName.$dirty && $v.form.fName.$invalid">
                        &nbsp; This feild is required
                      </span>
                    </div>
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.lName"
                        placeholder="Last Name"
                        @input="$v.form.lName.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.lName.$dirty && $v.form.lName.$invalid">
                        &nbsp; This feild is required
                      </span>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col">
                      <select class="form-control form-control-sm" v-model="form.country" placeholder="Country">
                        <option v-for="country in countries" :value="country.isoCode" :key="country.isoCode">
                          {{ country.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.phone"
                        placeholder="Phone Number"
                        @input="$v.form.phone.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.phone.$dirty && $v.form.phone.$invalid">
                        &nbsp; Bad phone number format
                      </span>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.address"
                        placeholder="Address"
                        @input="$v.form.address.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.address.$dirty && $v.form.address.$invalid">
                        &nbsp; This feild is required
                      </span>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.state"
                        placeholder="state or region"
                        @input="$v.form.state.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.state.$dirty && $v.form.state.$invalid">
                        &nbsp; This feild is required
                      </span>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.city"
                        placeholder="City"
                        @input="$v.form.city.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.city.$dirty && $v.form.city.$invalid">
                        &nbsp; This feild is required
                      </span>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="form.postcode"
                        placeholder="Postcode"
                        @input="$v.form.postcode.$touch()"
                      />
                      <span class="text-danger" v-if="$v.form.postcode.$dirty && $v.form.postcode.$invalid">
                        &nbsp; This feild is required
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex col-8 pt-5 m-auto">
            <button
              @click="setPaymentStep(1)"
              type="button"
              class="btn btn-success m-auto btn-sm px-6"
              :disabled="submitPayment"
            >
              BACK
            </button>

            <button
              @click="paymentSubmit()"
              type="button"
              class="btn btn-success m-auto btn-sm px-6"
              :disabled="submitPayment || $v.form.$invalid"
            >
              <span v-if="!submitPayment">PAY</span>
              <span v-if="submitPayment" class="spinner-border spinner-border-sm" role="status"></span>
              <span v-if="submitPayment" class="ml-2">PAY</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import CryptoJS from "crypto-js";
import { mapGetters, mapActions } from "vuex";
import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";
import { pagePreventLeave, pageLeave } from "@/assets/js/custom-function";
import Country from "@/assets/js/country-code-flag.json";

export default {
  name: "OperatorAddFund",

  data() {
    return {
      form: {
        buyerPhone: null,
        currencyAmount: null,
        amount: 0,
        country: null,
        phone: null,
        creditcard: "mobile",
      },
      title: null,
      paymentStep: null,
      paymentMethod: "mobile",
      countries: Country,
      currency: "USD",
      exchangeRate: 2308,
      submitPayment: false,
    };
  },

  computed: {
    ...mapGetters(["user"]),
  },

  mounted() {
    this.setPaymentStep(1);
    this.setPaymentMethod("mobile");

    this.hideBarLoading();
    pagePreventLeave();
  },

  validations() {
    if (this.paymentMethod == "mobile") {
      return {
        form: {
          buyerPhone: { required, numeric, minLength: minLength(9), maxLength: maxLength(9) },
        },
      };
    } else {
      return {
        form: {
          fName: { required },
          lName: { required },
          address: { required },
          state: { required },
          city: { required },
          postcode: { required },
          phone: { required, numeric, minLength: minLength(12), maxLength: maxLength(12) },
        },
      };
    }
  },

  methods: {
    ...mapActions(["hideBarLoading", "selcomPaymentCheckout"]),

    currencyToTzs() {
      this.form.amount = this.form.currencyAmount * this.exchangeRate;
    },

    setPaymentStep(step) {
      if (step == 1) {
        this.title = `AMOUNT IN ${this.currency}`;
        this.paymentStep = 1;
      } else if (step == 2) {
        this.title = "CHECKOUT";
        this.paymentStep = 2;
        this.setPaymentMethod(this.paymentMethod);
      }
    },

    setPaymentMethod(method) {
      if (!this.submitPayment) {
        if (method == "mobile") {
          this.paymentMethod = "mobile";
        } else if (method == "mastercard") {
          this.formClear();
          this.clientLocationDetect();
          this.paymentMethod = "mastercard";
        } else if (method == "visa") {
          this.formClear();
          this.clientLocationDetect();
          this.paymentMethod = "visa";
        }
      }
    },

    paymentSubmit() {
      this.submitPayment = true;
      const submitData = {};

      submitData["buyer_userid"] = this.user.id;
      submitData["buyer_name"] = this.user.companyName;
      submitData["buyer_email"] = this.user.username;
      submitData["amount"] = this.form.amount;
      submitData["currency"] = "TZS";
      submitData["no_of_items"] = 1;

      if (this.paymentMethod == "mobile") {
        submitData["payment_methods"] = "MOBILEMONEYPULL";
        submitData["buyer_phone"] = `255${this.form.buyerPhone}`;
      } else {
        submitData["buyer_phone"] = this.form.phone;
        submitData["payment_methods"] = "CARD";

        submitData["billing.firstname"] = this.form.fName;
        submitData["billing.lastname"] = this.form.lName;
        submitData["billing.address_1"] = this.form.address;
        submitData["billing.country"] = this.form.country;
        submitData["billing.city"] = this.form.city;
        submitData["billing.state_or_region"] = this.form.state;
        submitData["billing.postcode_or_pobox"] = this.form.postcode;
        submitData["billing.phone"] = this.form.phone;
      }
      // console.log(submitData);

      pageLeave();

      this.selcomPaymentCheckout(submitData).then((res) => {
        if (res.data.resultcode == "000") {
          const paymentGatewayUrl = res.data.data[0].payment_gateway_url;
          const urlWords = CryptoJS.enc.Base64.parse(paymentGatewayUrl);
          const urlString = CryptoJS.enc.Utf8.stringify(urlWords);

          window.location.href = urlString;
        } else {
          $.alert("Checkout payment failed");
          this.submitPayment = false;
        }
        // console.log(res.data);
      });
    },

    async clientLocationDetect() {
      const ipUrl = process.env.VUE_APP_IPREGISTRY_URL;
      const ipKey = process.env.VUE_APP_IPREGISTRY_SECRET_KEY;

      await axios
        .get(ipUrl, {
          headers: {
            Authorization: `ApiKey ${ipKey}`,
          },
        })
        .then((res) => {
          const countryCode = res.data.location.country.code;

          let index = this.countries.findIndex((x) => x.isoCode === countryCode);
          this.form.country = countryCode;
          this.form.phone = this.countries[index].dialCode.replace("+", "");
          // console.log(res);
        });
    },

    formClear() {
      $.extend(this.form, {
        country: null,
        phone: null,
      });
    },
  },
};
</script>
